import type { ForecastRow } from '../../supplychain/framework';

type Props = { forecasts?: ForecastRow[]; horizons?: string[] };

export function DemandForecastPanel({ forecasts = [], horizons = [] }: Props) {
  return (
    <div className="space-y-3">
      {horizons.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {horizons.map((h) => (
            <span key={h} className="rounded border border-slate-200 px-2 py-0.5 text-xs dark:border-slate-700">{h}</span>
          ))}
        </div>
      )}
      <div className="grid gap-3 grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
        {forecasts.map((f) => (
          <div key={f.horizon} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
            <p className="text-xs text-slate-500">{f.horizon} forecast</p>
            <p className="mt-1 text-lg font-semibold">{f.units.toLocaleString()} units</p>
            <p className="text-xs text-success-600">{f.change}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
